/* apex-preview.js — sample documents open in place, not in a new tab.

   Native <dialog>.showModal() so focus trapping, Escape, the backdrop and
   inertness of the page behind are all the browser's, not ours.

   The frame is loaded on open and emptied on close. A PDF left in an iframe
   keeps a plugin alive for every sample the reader has looked at, and eight of
   them is enough to feel.

   PREVIEW ONLY
   #toolbar=0&navpanes=0&scrollbar=0 are PDF open parameters: Chrome, Edge and
   Firefox drop the viewer's toolbar when they see them, which takes the
   download and print buttons with it.

   That hides the controls. It does not protect the file — the PDFs are public
   CDN URLs and anyone who wants one can fetch it. The watermark on every sample
   is the real protection; this just stops the preview looking like a download. */
(function () {
  var dlg = document.getElementById('apx-pv');
  if (!dlg || typeof dlg.showModal !== 'function') return;

  var frame = dlg.querySelector('[data-pv-frame]');
  var title = dlg.querySelector('[data-pv-title]');
  var opener = null;
  var VIEW_ONLY = '#toolbar=0&navpanes=0&scrollbar=0&view=FitH';

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pv-url]');
    if (b) {
      e.preventDefault();
      opener = b;
      var url = b.getAttribute('data-pv-url');
      var name = b.getAttribute('data-pv-name') || 'Sample document';
      title.textContent = name;
      frame.setAttribute('title', name);
      frame.src = url.split('#')[0] + VIEW_ONLY;
      dlg.showModal();
      /* the page behind a modal must not scroll under it */
      document.body.style.overflow = 'hidden';
      return;
    }
    /* clicking the backdrop is a click on the dialog itself, outside its box */
    if (e.target === dlg) dlg.close();
  });

  dlg.addEventListener('click', function (e) {
    if (e.target.closest('[data-pv-close]')) dlg.close();
  });

  dlg.addEventListener('close', function () {
    frame.removeAttribute('src');
    document.body.style.overflow = '';
    /* put focus back where it came from, or it lands on <body> */
    if (opener) { opener.focus(); opener = null; }
  });
})();
